import React, { useState } from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { AuthContext } from "./context/auth";
import { ColorModeProvider } from './context/colorMode/colorMode.context';
import { BrandingProvider, BrandingThemeProvider, getBrandingSessionKey } from './context/branding/branding.context';

import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';

// more feature rich npm package for excel parsing -> https://www.npmjs.com/package/xlsx

import ReactNotification from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';

import Routes from './Routes';
import {LOCAL_STORAGE_KEYS} from "./utils/constants";
import NetworkStatus from './components/NetworkStatus/NetworkStatus.comp';
import GlobalErrorDialog from './components/ErrorDialog/GlobalErrorDialog.comp';
import './utils/utils';
import './styles/darkMode.css';
import CssBaseline from "@material-ui/core/CssBaseline"; //to import string format function
import { TutorialProvider, TutorialManager, getTutorialSteps, tutorialEngineConfig } from './components/TutorialSystem';

import { DashboardProvider } from './context/DashboardContext';

const browserHistory = createBrowserHistory();

function App(props) {

    const existingToken = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const existingUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_user));

    const [authToken, setAuthToken] = useState(existingToken);
    const [authUser, setAuthUser] = useState(existingUser);

    const setToken = (data) => {
        localStorage.setItem(LOCAL_STORAGE_KEYS.auth_token, JSON.stringify(data));
        setAuthToken(data);
    }

    const setUser = (data) => {
        localStorage.setItem(LOCAL_STORAGE_KEYS.auth_user, JSON.stringify(data));
        setAuthUser(data);
    }

    const brandingKey = getBrandingSessionKey(authUser) || 'guest';

    return (
        <AuthContext.Provider value={{
            authToken,
            setAuthToken: setToken,
            authUser,
            setAuthUser: setUser
        }}>
            <ColorModeProvider>
                <BrandingProvider key={brandingKey}>
                    <Router history={browserHistory}>
                        <BrandingThemeProvider>
                        <DashboardProvider>
                        <TutorialProvider
                            stepsConfig={authUser ? getTutorialSteps(authUser) : []}
                            engineConfig={tutorialEngineConfig}
                            authUser={authUser}
                        >
                            <div className="app-container">
                                <NetworkStatus />
                                <CssBaseline />
                                <ReactNotification />
                                <GlobalErrorDialog />
                                <TutorialManager />
                                <Routes />
                            </div>
                        </TutorialProvider>
                        </DashboardProvider>
                    </BrandingThemeProvider>
                </Router>
            </BrandingProvider>
            </ColorModeProvider>
        </AuthContext.Provider>
    );
}

export default App;
